/* Version 1 (den gamla appen) fasas ut. Datumen står bara här (Fahd 12 okt, Motion tk_dzLtkG4QCpLb3kbv31ZsvY):
   v3 är standard från 14 okt, ?ui=v1 i adressen fungerar till och med UI_V1_SISTA_DAG, och valet "Använd gamla
   versionen (v1)" i Inställningar > Gränssnitt till och med V1_SISTA_DAG. Därefter styr spärren till v3. v1:s egna
   länkar (säljarlänken, ?onboarding=, ?anslut=, mejlens Ekonomi-länkar) öppnar v1 som förut, de har ingen v3-sida.
   Att ta bort v1-koden helt är en egen Motion-task. */
export const UI_V1_SISTA_DAG = '2026-10-28';
export const V1_SISTA_DAG = '2026-11-14';
const V1_VALD = 'mb.v1Vald';   // localStorage: bokaren har valt v1 i Inställningar

const lokalIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

/** Sista dagen som text, till knappar och rader: "14 nov". Följer V1_SISTA_DAG, så att texten aldrig går fel mot datumet. */
const MANADER = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
export const v1SistaDagText = (iso = V1_SISTA_DAG) => { const [, m, d] = iso.split('-'); return `${Number(d)} ${MANADER[Number(m) - 1]}`; };

/** true till och med sista dagen (lokal tid). */
export const harVersion1 = (nu = new Date()) => lokalIso(nu) <= V1_SISTA_DAG;

const lasV1Vald = () => { try { return localStorage.getItem(V1_VALD) === '1'; } catch { return false; } };
const sparaV1Vald = (ja) => { try { if (ja) localStorage.setItem(V1_VALD, '1'); else localStorage.removeItem(V1_VALD); } catch { /* privat läge */ } };

/** Valet i Inställningar: sparas i webbläsaren och gäller tills bokaren byter tillbaka eller V1_SISTA_DAG passerat. */
export const tillVersion1 = () => { sparaV1Vald(true); window.location.assign('/'); };
/** v1:s knapp tillbaka. ?ui=v3 så att den nya versionen öppnas även på map.*, där startsidan är kartan. */
export const tillVersion3 = () => { sparaV1Vald(false); window.location.assign('/?ui=v3'); };
export const anvanderValtV1 = (nu = new Date()) => lasV1Vald() && harVersion1(nu);

/* Värdnamnen (Fahd 12 okt): map.* och www.map.* har Kommunkartan som startsida, och den finns bara i v1 (v1 utan
   ?vy= öppnar kartan). meeting.* (och booking.*, som v1 redan behandlar likadant) visar mötesbokningen i v3.
   Bara den rena adressen styrs, så att alla länkar med parametrar fungerar som förut. Okänt värdnamn: som förut. */
const PA_MAP = /^(www\.)?map\./i;
const PA_MEETING = /^(booking|meeting)\./i;

/** 'v1' eller 'v3'. Spärren och värdnamnen ligger ovanpå wantsV2 (entry.js), vars svar (v3) avgör allt annat. */
export function valjVersion(location, v3, nu = new Date(), v1Vald = lasV1Vald()) {
  let ui = null;
  try { ui = new URLSearchParams(location.search).get('ui'); } catch { /* som förut */ }
  // ?ui=v3 är alltid vägen tillbaka: valet av v1 glöms, annars öppnar nästa rena adress v1 igen (Fahd 20 okt).
  if (ui === 'v3' && v1Vald) { sparaV1Vald(false); v1Vald = false; }
  if (ui === 'v1') return lokalIso(nu) <= UI_V1_SISTA_DAG ? 'v1' : 'v3';
  if (!ui && v1Vald && harVersion1(nu)) return 'v1';
  if (!ui && !location.search) {
    const vard = location.hostname || '';
    if (PA_MAP.test(vard)) return 'v1';
    if (PA_MEETING.test(vard)) return 'v3';
  }
  // Prospects-exemplet (?testdata) finns bara i v1: på map.* ska just den adressen öppna kartan, inte v3.
  if (PA_MAP.test(location.hostname || '') && /^\?testdata(=1?)?$/.test(location.search)) return 'v1';
  return v3 ? 'v3' : 'v1';
}
